import ApiService from "./ApiService";

const UserService = {
    getAllUsers(page) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/user/list?page=' + page).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },

    getUserWithId(userId) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/user/' + userId).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    createUser(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/user/create', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    updateUser(data) {
        return new Promise((resolve, reject) => {
            ApiService.put('/user/' + data.id, data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    changePasswordUser(data, userId) {
        return new Promise((resolve, reject) => {
            ApiService.put('/user/' + userId + '/change-password', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    deleteUser(userId) {
        return new Promise((resolve, reject) => {
            ApiService.delete('/user/' + userId).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }
};

export default UserService